// extracted by mini-css-extract-plugin
var _1 = "Sidebar_boardButton__9TAPK";
var _2 = "Sidebar_boardCannotManage__Uwolm";
var _3 = "Sidebar_boardDraggable__HFMoF";
var _4 = "Sidebar_collapseIcon__jv3Lh";
var _5 = "Sidebar_collapseIconCollapsed__+kDVU";
var _6 = "Sidebar_content__lD3bT";
var _7 = "Sidebar_contentCompact__gT7Wo";
var _8 = "Sidebar_footerButton__HlUvn";
var _9 = "Sidebar_footerButtonIcon__pbyzR";
var _a = "Sidebar_githubCannotManage__59rFr";
var _b = "Sidebar_githubGreen__rIW+X";
var _c = "Sidebar_githubGrey__wPe1v";
var _d = "Sidebar_githubNotifications__g8Rrm";
var _e = "Sidebar_githubNotificationsCannotManage__idVyK";
var _f = "Sidebar_hoverButton__3QO5F";
var _10 = "Sidebar_icon__45Dek";
var _11 = "Sidebar_notification__D3cTn";
var _12 = "Sidebar_notificationNonManager__NTQLo";
var _13 = "Sidebar_reorderBoardsButton__jIPnu";
var _14 = "Sidebar_scrollable__H9d++";
var _15 = "Sidebar_sidebar__x32HG";
var _16 = "Sidebar_sidebarActive__BvoI1";
var _17 = "Sidebar_sidebarButton__Ijjng";
var _18 = "Sidebar_sidebarButtonPadding__TfjhA";
var _19 = "Sidebar_sidebarCompact__sKuwP";
var _1a = "Sidebar_sidebarHidden__Uxbij";
var _1b = "Sidebar_sidebarItem__kqQp0";
var _1c = "Sidebar_sidebarItemActive__dVNYH";
var _1d = "Sidebar_sidebarItemBoard__RchCi";
var _1e = "Sidebar_sidebarItemInner__dF852";
var _1f = "Sidebar_sidebarItemProject__nWjC8";
var _20 = "Sidebar_sidebarTitle__BSllT";
var _21 = "Sidebar_sidebarTitleIcon__Fj8R7";
var _22 = "Sidebar_toggleSidebarButton__BdAYI";
var _23 = "Sidebar_wrapper__4x7Tf";
export { _1 as "boardButton", _2 as "boardCannotManage", _3 as "boardDraggable", _4 as "collapseIcon", _5 as "collapseIconCollapsed", _6 as "content", _7 as "contentCompact", _8 as "footerButton", _9 as "footerButtonIcon", _a as "githubCannotManage", _b as "githubGreen", _c as "githubGrey", _d as "githubNotifications", _e as "githubNotificationsCannotManage", _f as "hoverButton", _10 as "icon", _11 as "notification", _12 as "notificationNonManager", _13 as "reorderBoardsButton", _14 as "scrollable", _15 as "sidebar", _16 as "sidebarActive", _17 as "sidebarButton", _18 as "sidebarButtonPadding", _19 as "sidebarCompact", _1a as "sidebarHidden", _1b as "sidebarItem", _1c as "sidebarItemActive", _1d as "sidebarItemBoard", _1e as "sidebarItemInner", _1f as "sidebarItemProject", _20 as "sidebarTitle", _21 as "sidebarTitleIcon", _22 as "toggleSidebarButton", _23 as "wrapper" }
